import React, { useState } from 'react';
import Welcome from './components/Welcome';
import NameEntry from './components/NameEntry';
import BoissonsList from './components/BoissonsList';
import Confirmation from './components/Confirmation';
import AdminPanel from './components/AdminPanel';

export default function App() {
  const [step, setStep] = useState('welcome'); // welcome | name | boissons | confirmation | admin
  const [participant, setParticipant] = useState(null);
  const [choix, setChoix] = useState({});

  if (step === 'admin') return <AdminPanel onBack={() => setStep('welcome')} />;

  if (step === 'welcome') return (
    <Welcome
      onStart={() => setStep('name')}
      onAdmin={() => setStep('admin')}
    />
  );

  if (step === 'name') return (
    <NameEntry
      onSuccess={(p, c) => {
        setParticipant(p);
        setChoix(c);
        setStep('boissons');
      }}
      onBack={() => setStep('welcome')}
    />
  );

  if (step === 'boissons') return (
    <BoissonsList
      participant={participant}
      initialChoix={choix}
      onConfirm={(finalChoix) => {
        setChoix(finalChoix);
        setStep('confirmation');
      }}
      onBack={() => setStep('name')}
    />
  );

  if (step === 'confirmation') return (
    <Confirmation
      participant={participant}
      choix={choix}
      onModify={() => setStep('boissons')}
      onDone={() => setStep('welcome')}
    />
  );

  return null;
}
